import React from "react";

function FitIcon() {
  return (
    <svg
      fill="#000000"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        border: "3px solid black",
        padding: "3px",
        borderRadius: "5px",
      }}
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <path d="M5.85,5.15a.48.48,0,0,1,0,.7.48.48,0,0,1-.7,0L1,1.71V3.5A.5.5,0,0,1,.5,4,.5.5,0,0,1,0,3.5V.5A.41.41,0,0,1,0,.31.51.51,0,0,1,.31,0,.41.41,0,0,1,.5,0h3A.5.5,0,0,1,4,.5a.5.5,0,0,1-.5.5H1.71ZM16,12.5a.5.5,0,0,0-1,0v1.79l-4.15-4.14a.49.49,0,0,0-.7.7L14.29,15H12.5a.5.5,0,0,0,0,1h3a.41.41,0,0,0,.19,0,.51.51,0,0,0,.27-.27.41.41,0,0,0,0-.19Z"></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default FitIcon;
